<template>
  <pop-up-layout 
    :loading="waitingForLoad" 
    :saving="saving" 
    :title="$t('reservas.listas.eliminarReserva')">
    <v-layout column justify-center align-center>
      <o-description-title>
        {{pregunta}}
      </o-description-title>
      <v-img 
        style="margin-bottom: 30px; width:180px;" 
        :src="require('@/assets/images/WARNING_GRIS.png')"
      />
      <o-description-title colorClass="error--text">
        {{avisoPago}}
      </o-description-title>
      <o-description-title>
        {{$t('reservas.listas.alertaIrreversible')}}
      </o-description-title>
    </v-layout>
    <v-layout wrap justify-center align-center slot="acciones">
      <v-btn 
        color="primary" 
        @click="$emit('aceptar',false)"
        :disabled="saving || waitingForLoad"
      >
        {{$t('reservas.listas.cancelar')}}
      </v-btn>
      <v-btn 
        color="primary" 
        @click="$emit('aceptar',true)"
        :disabled="saving || waitingForLoad"
        :loading="saving"
      >
       {{$t('reservas.listas.eliminar')}}
      </v-btn>
    </v-layout>
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    reservaId: {
      required: true
    },
    pregunta: {
      default: ''
    },
    saving: {
      default: false
    }
  },
  data () {
    return {
      waitingForLoad: false
    }
  },
  async created () {
    try {
      this.waitingForLoad = true
      await this.loadReserva(this.reservaId)
      let r = await this.comprobarEliminarBO(this.reservaId)
      if (r.estado === 93) {
        this.$emit('eliminadaBO', r)
      }
      this.waitingForLoad = false
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
      this.$emit('aceptar', false)
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
    avisoPago () {
      if (this.reserva && this.reserva.pago != null && [5, 10, 20].includes(this.reserva.estadoPago.codigoEstadoPago)) {
        if (this.reserva.pago.tipo === 'transferencia') {
          return this.$t('reservas.listas.recordatorioPago')
        } else if (this.reserva.pago.tipo === 'stripe') {
          return this.$t('reservas.listas.recordatorioPagoPlataforma')
        }
      }
      return null
    }
  },
  methods: {
    ...mapActions({
      loadReserva: 'reservas/_id/load',
      comprobarEliminarBO: 'reservas/comprobar_eliminar_bo',
      addAlert: 'alerts/add'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/listas/PopUpEliminarReserva.vue